import { FC, useContext } from 'react';

import { Checkbox, Select } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { ITariffsFiltersProps } from './interfaces';
import s from './TariffsFilters.module.scss';

export const TariffsFilters: FC<ITariffsFiltersProps> = ({
  activeFilters,
  host_groups,
  setActiveFilters,
}) => {
  const { t } = useContext(LocalizationContext);
  return (
    <div className={s.container}>
      <Select
        name="host_group_filter"
        title={t('tariffs.filters.group')}
        value={activeFilters.host_group?.value || null}
        onChange={(value) =>
          setActiveFilters({
            ...activeFilters,
            host_group: { ...activeFilters.host_group, value: value || '' },
          })
        }
        options={host_groups}
        className={s['select']}
      />
      <div className={s.checkbox_block}>
        <Checkbox
          label={t('tariffs.filters.active')}
          value={activeFilters.is_active}
          onChange={() =>
            setActiveFilters({
              ...activeFilters,
              is_active: !activeFilters.is_active,
            })
          }
        />
        <Checkbox
          label={t('tariffs.filters.package')}
          value={activeFilters.has_fixed_finish_time}
          onChange={() =>
            setActiveFilters({
              ...activeFilters,
              has_fixed_finish_time: !activeFilters.has_fixed_finish_time,
            })
          }
        />
        <Checkbox
          label={t('tariffs.filters.discount')}
          value={activeFilters.use_global_discounts}
          onChange={() =>
            setActiveFilters({
              ...activeFilters,
              use_global_discounts: !activeFilters.use_global_discounts,
            })
          }
        />
      </div>
    </div>
  );
};
